import React, { useMemo } from 'react';

import { OPTIONS, optionByAngle } from './components/Options.jsx'
import generateKeyRings from './components/generateKeyRings.js'

const useKeysByOption = (width, height, top, left, center_x, center_y) => {
	return useMemo(()=>{
		const keys_by_option = OPTIONS.map(()=>([]))

		generateKeyRings({
			width: width,
			height: height,
			center_x,
			center_y,
			onKeyPositionGenerated: (key_position, ring_index) => {
				const option_index = optionByAngle(key_position.angle)

				if(option_index === -1){
					return
				}

				const keys = keys_by_option[option_index]

				if(!keys[ring_index]){
					keys[ring_index] = []
				}

				keys[ring_index].push(key_position)
			}
		})

		return keys_by_option.map(keys => _.zip(...keys))
	}, [width, height, top, left])
}

export default useKeysByOption